import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Inject,
  ViewChild
} from '@angular/core';
import { RegistroActividadAlmacenamientoFormComponent } from '../registro-actividad-almacenamiento-form.component';
import { entityDepositosAddRequest } from '../../entity-depositos/depositos.actions';
import { Deposito } from '../../entity-depositos/depositos.model';
import { Store, select } from '@ngrx/store';
import { State } from '../../../vista-usuario/vista-usuario.state';
import { Subscription } from 'rxjs';
import { NotificationService } from 'projects/registro-personas-empresas/src/app/core/core.module';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RegistroActividadLaboratorioFormContainerComponent } from '../../registro-actividad-laboratorio-form/registro-actividad-laboratorio-form-container/registro-actividad-laboratorio-form-container.component';
import { selectAllDepositosFromCurrentEmpresa } from '../../entity-depositos/depositos.selectors';

@Component({
  selector: 'rpe-registro-actividad-almacenamiento-form-container',
  templateUrl:
    './registro-actividad-almacenamiento-form-container.component.html',
  styleUrls: [
    './registro-actividad-almacenamiento-form-container.component.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RegistroActividadAlmacenamientoFormContainerComponent
  implements OnInit
{
  @ViewChild(RegistroActividadAlmacenamientoFormComponent)
  formComponent: RegistroActividadAlmacenamientoFormComponent;

  subscriptions: Subscription[] = [];

  deposito: Deposito = null;
  depositosCurrentEmpresa: Deposito[] = [];
  newDeposito: Deposito = null

  formInvalid: boolean = false;

  constructor(
    private store: Store<State>,
    private notificationService: NotificationService,
    private dialogRef: MatDialogRef<RegistroActividadLaboratorioFormContainerComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      deposito?: Deposito;
    }
  ) {}

  ngOnInit(): void {
    this.store
      .pipe(select(selectAllDepositosFromCurrentEmpresa))
      .subscribe((labs) => {
        this.depositosCurrentEmpresa = labs;
      });

    if (this.data.deposito) {
      this.deposito = this.data.deposito;
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions.length) {
      this.subscriptions.forEach((s) => s.unsubscribe());
    }
   }

  formStatusChange(status: string): void {
    if (status === 'INVALID') {
      this.formInvalid = true;
    }

    if (status === 'VALID') {
      this.formInvalid = false;
    }

    if (status != 'INVALID' && status != 'VALID') {
      this.formInvalid = true;
    }
  }

  formValueChange($event: Deposito): void {
    const editedDepositIndex = this.depositosCurrentEmpresa.findIndex(
      (dep) => dep.id === $event.id
    );
  
  
    if (editedDepositIndex !== -1) {
      // Editar el depósito existente
      this.depositosCurrentEmpresa[editedDepositIndex] = $event;
    } else {
      this.newDeposito = $event
    }
  }
  
  onAdd(): void {
    if (this.formInvalid) {
      this.notificationService.info('Complete los campos requeridos');
      this.formComponent?.onShowErrors();
      return;
    }

    if (this.newDeposito) {
      this.depositosCurrentEmpresa = [...this.depositosCurrentEmpresa, this.newDeposito];
    }

    this.store.dispatch(
      entityDepositosAddRequest({
        item: this.depositosCurrentEmpresa
      })
    );

    this.dialogRef.close();
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
